module.exports = __webpack_public_path__ + "static/media/routes09.41b53dbd.webp";